






















import { Component, Vue, PropSync } from "vue-property-decorator";

@Component
class UnPaidOrderModal extends Vue {
  @PropSync("visible") bindVisible;

  handleViewOrder() {
    this.$helper.toFusionPath(this, "defi", { name: "orders" });
  }
}
export default UnPaidOrderModal;
